import {
    AppCommonFiltersAcrissAutocomplete,
    AppCommonFiltersAcrissCategoryToggleButton,
    AppCommonFiltersCategoriesAutocomplete,
    AppCommonFiltersCurrencyAutocomplete,
    AppCommonFiltersCurrencySelect,
    AppCommonFiltersDailyPriceToggleButton,
    AppCommonFiltersDateRangePicker,
    AppCommonFiltersDirectSiteBrokerProviderToggleButton,
    AppCommonFiltersDropoffOfficesAutocomplete,
    AppCommonFiltersEndHourPicker,
    AppCommonFiltersExcludeProvidersSelect,
    AppCommonFiltersExcludeWebSuppliersSelect,
    AppCommonFiltersFuelPolicyAutocomplete,
    AppCommonFiltersFuelPolicySelect,
    AppCommonFiltersGroupByAutocomplete,
    AppCommonFiltersHowToGroupAutocomplete,
    AppCommonFiltersInsuranceAutocomplete,
    AppCommonFiltersInsuranceSelect,
    AppCommonFiltersInTerminalAutocomplete,
    AppCommonFiltersInTerminalSelect,
    AppCommonFiltersLengthOfRentalAutocomplete,
    AppCommonFiltersLengthOfRentalSelect,
    AppCommonFiltersMainProvidersAutocomplete,
    AppCommonFiltersMainSitesAutocomplete,
    AppCommonFiltersMileageAutocomplete,
    AppCommonFiltersMileageSelect,
    AppCommonFiltersOfficesAutocomplete,
    AppCommonFiltersPeriodCompareInput,
    AppCommonFiltersPeriodCompareToggleButton,
    AppCommonFiltersPrepaidAutocomplete,
    AppCommonFiltersPrepaidSelect,
    AppCommonFiltersPriceKpiToggleButton,
    AppCommonFiltersProvidersAutocomplete,
    AppCommonFiltersRentalDatesMultiPicker,
    AppCommonFiltersRentalLengthTags,
    AppCommonFiltersShowFeatures,
    AppCommonFiltersSingleDatePicker,
    AppCommonFiltersSitesAutocomplete,
    AppCommonFiltersStartHourPicker,
    AppCommonFiltersTiersAutocomplete,
    AppCommonFiltersTransmissionAutocomplete,
    AppCommonFiltersTransmissionSelect,
    AppCommonFiltersUsersAutocomplete,
    AppCommonFiltersWebProviderToggleButton,
    AppCommonFiltersWebSuppliersAutocomplete,
    AppCommonFiltersShowDropoffOffices,
    AppCommonFiltersBookingWeeks,
    AppCommonFiltersMarkets,
    AppCommonFiltersSiteMarketToggleButton,
    AppCommonFiltersOfficeGroupToggleButton,
    AppCommonFiltersOfficeGroupAutocomplete,
    AppCommonFiltersSiteGroupToggleButton,
    AppCommonFiltersSiteGroupAutocomplete,
    AppCommonFiltersMainSiteProviderToggleButton
} from './@components'
import { COMMON_FILTERS_COMPONENTS } from '@constants'

export const COMPONENTS = {
	[COMMON_FILTERS_COMPONENTS.BLANK]: null,
	[COMMON_FILTERS_COMPONENTS.OFFICE_PICKUP]: AppCommonFiltersOfficesAutocomplete,
	[COMMON_FILTERS_COMPONENTS.OFFICE_DROPOFF]: AppCommonFiltersDropoffOfficesAutocomplete,
	[COMMON_FILTERS_COMPONENTS.MAIN_SITE]: AppCommonFiltersMainSitesAutocomplete,
	[COMMON_FILTERS_COMPONENTS.SITE]: AppCommonFiltersSitesAutocomplete,
	[COMMON_FILTERS_COMPONENTS.MAIN_PROVIDER]: AppCommonFiltersMainProvidersAutocomplete,
	[COMMON_FILTERS_COMPONENTS.PROVIDERS]: AppCommonFiltersProvidersAutocomplete,
	[COMMON_FILTERS_COMPONENTS.EXTRA_PROVIDERS]: AppCommonFiltersExcludeProvidersSelect,
	[COMMON_FILTERS_COMPONENTS.WEB_SUPPLIERS]: AppCommonFiltersWebSuppliersAutocomplete,
	[COMMON_FILTERS_COMPONENTS.TIERS]: AppCommonFiltersTiersAutocomplete,
	[COMMON_FILTERS_COMPONENTS.CATEGORIES]: AppCommonFiltersCategoriesAutocomplete,
	[COMMON_FILTERS_COMPONENTS.EXTRA_CATEGORIES]: AppCommonFiltersAcrissCategoryToggleButton,
	[COMMON_FILTERS_COMPONENTS.RENTAL_DATES]: AppCommonFiltersRentalDatesMultiPicker,
	[COMMON_FILTERS_COMPONENTS.DATE_RANGE]: AppCommonFiltersDateRangePicker,
	[COMMON_FILTERS_COMPONENTS.DATES]: AppCommonFiltersRentalDatesMultiPicker,
	[COMMON_FILTERS_COMPONENTS.SINGLE_DATE]: AppCommonFiltersSingleDatePicker,
	[COMMON_FILTERS_COMPONENTS.RENTAL_LENGTH]: AppCommonFiltersLengthOfRentalAutocomplete,
	[COMMON_FILTERS_COMPONENTS.BOOKING_DATE]: AppCommonFiltersDateRangePicker,
	[COMMON_FILTERS_COMPONENTS.START_HOUR]: AppCommonFiltersStartHourPicker,
	[COMMON_FILTERS_COMPONENTS.END_HOUR]: AppCommonFiltersEndHourPicker,
	[COMMON_FILTERS_COMPONENTS.ANALYZER_ACRISS]: AppCommonFiltersAcrissAutocomplete,
	[COMMON_FILTERS_COMPONENTS.CURRENCY]: AppCommonFiltersCurrencyAutocomplete,
	[COMMON_FILTERS_COMPONENTS.USERS]: AppCommonFiltersUsersAutocomplete,
	[COMMON_FILTERS_COMPONENTS.DAILY_PRICE_TOGGLE]: AppCommonFiltersDailyPriceToggleButton,
	[COMMON_FILTERS_COMPONENTS.ACRISS]: AppCommonFiltersAcrissAutocomplete,
	[COMMON_FILTERS_COMPONENTS.MILEAGE]: AppCommonFiltersMileageAutocomplete,
	[COMMON_FILTERS_COMPONENTS.TRANSMISSION]: AppCommonFiltersTransmissionAutocomplete,
	[COMMON_FILTERS_COMPONENTS.FUEL_POLICY]: AppCommonFiltersFuelPolicyAutocomplete,
	[COMMON_FILTERS_COMPONENTS.INSURANCE]: AppCommonFiltersInsuranceAutocomplete,
	[COMMON_FILTERS_COMPONENTS.PREPAID]: AppCommonFiltersPrepaidAutocomplete,
	[COMMON_FILTERS_COMPONENTS.IN_TERMINAL]: AppCommonFiltersInTerminalAutocomplete,
	[COMMON_FILTERS_COMPONENTS.GROUP_BY]: AppCommonFiltersGroupByAutocomplete,
	[COMMON_FILTERS_COMPONENTS.HOW_TO_GROUP]: AppCommonFiltersHowToGroupAutocomplete,
	[COMMON_FILTERS_COMPONENTS.IS_PREV_COMPARISON]: AppCommonFiltersPeriodCompareToggleButton,
	[COMMON_FILTERS_COMPONENTS.SHOW_FEATURES]: AppCommonFiltersShowFeatures,
	[COMMON_FILTERS_COMPONENTS.BROKERS]: AppCommonFiltersDirectSiteBrokerProviderToggleButton,
	[COMMON_FILTERS_COMPONENTS.WEB_SUPPLIER_TOGGLE]: AppCommonFiltersWebProviderToggleButton,
	[COMMON_FILTERS_COMPONENTS.EXCLUDE_WEB_SUPPLIERS]: AppCommonFiltersExcludeWebSuppliersSelect,
	[COMMON_FILTERS_COMPONENTS.RENTAL_LENGTH_SELECT]: AppCommonFiltersLengthOfRentalSelect,
	[COMMON_FILTERS_COMPONENTS.RENTAL_LENGTH_TAGS]: AppCommonFiltersRentalLengthTags,
	[COMMON_FILTERS_COMPONENTS.CURRENCY_SELECT]: AppCommonFiltersCurrencySelect,
	[COMMON_FILTERS_COMPONENTS.TRANSMISSION_SELECT]: AppCommonFiltersTransmissionSelect,
	[COMMON_FILTERS_COMPONENTS.FUEL_POLICY_SELECT]: AppCommonFiltersFuelPolicySelect,
	[COMMON_FILTERS_COMPONENTS.INSURANCE_SELECT]: AppCommonFiltersInsuranceSelect,
	[COMMON_FILTERS_COMPONENTS.IN_TERMINAL_SELECT]: AppCommonFiltersInTerminalSelect,
	[COMMON_FILTERS_COMPONENTS.MILEAGE_SELECT]: AppCommonFiltersMileageSelect,
	[COMMON_FILTERS_COMPONENTS.PREPAID_SELECT]: AppCommonFiltersPrepaidSelect,
	[COMMON_FILTERS_COMPONENTS.PRICE_KPI]: AppCommonFiltersPriceKpiToggleButton,
	[COMMON_FILTERS_COMPONENTS.PREV_COMPARISON]: AppCommonFiltersPeriodCompareInput,
	[COMMON_FILTERS_COMPONENTS.SHOW_DROPOFF]: AppCommonFiltersShowDropoffOffices,
	[COMMON_FILTERS_COMPONENTS.PREV_COMPARISON]: AppCommonFiltersPeriodCompareInput,
	[COMMON_FILTERS_COMPONENTS.BOOKING_WEEKS]: AppCommonFiltersBookingWeeks,
	[COMMON_FILTERS_COMPONENTS.MARKETS]: AppCommonFiltersMarkets,
	[COMMON_FILTERS_COMPONENTS.SITE_MARKET_TOGGLE]: AppCommonFiltersSiteMarketToggleButton,
    [COMMON_FILTERS_COMPONENTS.IS_OFFICE_GROUP]: AppCommonFiltersOfficeGroupToggleButton,
    [COMMON_FILTERS_COMPONENTS.OFFICE_GROUP]: AppCommonFiltersOfficeGroupAutocomplete,
    [COMMON_FILTERS_COMPONENTS.IS_SITE_GROUP]: AppCommonFiltersSiteGroupToggleButton,
    [COMMON_FILTERS_COMPONENTS.SITE_GROUP]: AppCommonFiltersSiteGroupAutocomplete,
    [COMMON_FILTERS_COMPONENTS.MAIN_SITE_PROVIDER_TOGGLE]: AppCommonFiltersMainSiteProviderToggleButton,

}

